<template>
  <v-container>
    <v-row dense>
      <v-col cols="12" xs="12" sm="12">
        <highcharts :options="chartOptions"></highcharts>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
/* eslint-disable no-debugger */
import { Chart } from "highcharts-vue";
import { mapState } from "vuex";

export default {
  name: "chartCLientes",
  data() {
    return {
      title: "Clientes por zona",
    };
  },
  components: {
    highcharts: Chart,
  },
  props: {
    speed: Array,
    modo: String,
  },
  crated() {
    this.listar();
  },
  computed: {
    ...mapState("usuarioNamespace", ["token"]),
    chartOptions() {
      return {
        chart: { type: this.modo },
        title: { text: this.title },
        tooltip: {
          pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
        },
        accessibility: {
          point: {
            valueSuffix: "%",
          },
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            dataLabels: {
              enabled: false,
            },
            showInLegend: true,
          },
        },
        series: [
          {
            name: "Brands",
            colorByPoint: true,
            data: [
              {
                name: "Zona 1",
                y: 61.41,
                sliced: true,
                selected: true,
              },
              {
                name: "Zona 2",
                y: 11.84,
              },
              {
                name: "Zona 3",
                y: 10.85,
              },
              {
                name: "Zona 4",
                y: 4.67,
              },
            ],
          },
        ],
      };
    },
  },
};
/* eslint-disable no-debugger */
</script>
